import { render, staticRenderFns } from "./ManageChannel.vue?vue&type=template&id=599165c4&scoped=true&"
import script from "./ManageChannel.vue?vue&type=script&lang=js&"
export * from "./ManageChannel.vue?vue&type=script&lang=js&"
import style0 from "./ManageChannel.vue?vue&type=style&index=0&id=599165c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599165c4",
  null
  
)

export default component.exports